// Copyright 2024 Linka Cloud  All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react';

export interface ForProps<T> {
  each: T[] | readonly T[] | undefined;
  fallback?: React.ReactNode;
  children: (item: Exclude<T, undefined>, index: number) => React.ReactNode;
}

export const For = <T,>(props: ForProps<T>): React.ReactNode => {
  const { each, fallback, children } = props;
  if (each?.length === 0) {
    return fallback || null;
  }
  return each?.map(children as any);
};

For.displayName = 'For';
